import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hbysgpviifpcqrtqjmkv.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhieXNncHZpaWZwY3FydHFqbWt2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg3MzY4MTEsImV4cCI6MjA1NDMxMjgxMX0.heVkWsdOu0My3JxM17AcDfsnBbbdhnOUiAhSmkJ-DAY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export const signInWithGoogle = async () => {
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    });
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error signing in with Google:', error);
    return { data: null, error };
  }
};
